import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useAgentSchedulerStateContext } from 'Context/NewAgentSchedulerContext';
import NextMeeting from './NextMeeting';
import UnableToSchedule from './UnableToSchedule';
import MonthlyCalendar from './MonthlyCalendar';
import WeeklyCalendar from './WeeklyCalendar';
import NewMeeting from './NewMeeting';

const styles = () => ({
  spinnerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
  spinner: {
    height: '100%',
    width: '100%',
  },
});

const ViewContainer = ({ classes }) => {
  const { view, loading } = useAgentSchedulerStateContext();
  if (loading) {
    return (
      <div className={classes.spinnerContainer}>
        <CircularProgress className={classes.spinner} />
      </div>
    );
  }

  switch (view) {
    case 'week':
      return <WeeklyCalendar />;
    case 'newMeeting':
      return <NewMeeting />;
    case 'nextMeeting':
      return <NextMeeting />;
    case 'month':
      return <MonthlyCalendar />;
    case 'error':
      return <UnableToSchedule />;
    default:
      return null;
  }
};

export default withStyles(styles)(ViewContainer);
